// extracted by mini-css-extract-plugin
export default {"profile-header-title":"profile_profile-header-title__mwz1D","profile-sheets":"profile_profile-sheets__SzbR7"};